import { addInspirations, removeInspirations } from 'adapters/list';
import { logAddInspiration, logRemoveInspiration, logShowInspirations } from 'helpers/analytics';
import { activeExperiments, track } from 'helpers/optimizely';
import {
    InspirationEvent,
    InspirationPayload,
    UPDATE_DATA,
    UpdateDataEvent,
    UpdateDataPayload,
    publish,
} from 'helpers/pubsub';
import { updateInspirationsStore } from 'helpers/store';
import {
    ADD_INSPIRATION_FAILURE,
    ADD_INSPIRATION_LOADING,
    ADD_INSPIRATION_REQUEST,
    ADD_INSPIRATION_SUCCESS,
    REMOVE_INSPIRATION_FAILURE,
    REMOVE_INSPIRATION_LOADING,
    REMOVE_INSPIRATION_REQUEST,
    REMOVE_INSPIRATION_SUCCESS,
} from 'helpers/pubsub';
import fetchPhraseIfNeeded from 'helpers/utils/fetch-phrase-if-needed';
import translate from 'helpers/utils/translate';
import { ListOverview } from 'helpers/optimizely/experiments';
import { favouritesUrl } from 'utils/settings';
import { reportError } from 'helpers/sentry';

const moveToInspirations = () => {
    logShowInspirations();
    if (activeExperiments[ListOverview.name] === ListOverview.variations.On) {
        window.location.href = `${favouritesUrl}?tab=ideaboard`;
    } else {
        window.location.href = `${favouritesUrl}inspiration`;
    }
};
const handleAddInspirationSubscription = async (payload: InspirationPayload) => {
    try {
        await fetchPhraseIfNeeded();
        publish(ADD_INSPIRATION_LOADING, payload);
        await addInspirations(payload.ids)
            .then(response => {
                if (!response?.errors) {
                    logAddInspiration(payload);
                    updateInspirationsStore(response?.data?.inspirations);
                    publish(ADD_INSPIRATION_SUCCESS, payload);
                    track('favourites_added_inspiration');
                    window?.ikea?.toast(
                        translate('AGENT_INSPIRATIONS_TOAST_SAVED'),
                        {
                            label: translate('AGENT_TOAST_SHOW'),
                            callbackOrHref: moveToInspirations,
                        },
                        null
                    );
                }
            })
            .catch(() => {
                publish(ADD_INSPIRATION_FAILURE, payload);
                window?.ikea?.toast(translate('GENERIC_ERROR_TOAST'));
            });
    } catch (e) {
        reportError(e as Error);
    }
};

const handleRemoveInspirationSubscription = async (payload: InspirationPayload) => {
    try {
        await fetchPhraseIfNeeded();
        publish(REMOVE_INSPIRATION_LOADING, payload);
        await removeInspirations(payload.ids)
            .then(response => {
                if (!response?.errors) {
                    logRemoveInspiration(payload);
                    updateInspirationsStore(response?.data?.inspirations);
                    publish(REMOVE_INSPIRATION_SUCCESS, payload);
                    window?.ikea?.toast(translate('AGENT_INSPIRATIONS_TOAST_REMOVED'));
                }
            })
            .catch(() => {
                publish(REMOVE_INSPIRATION_FAILURE, payload);
                window?.ikea?.toast(translate('GENERIC_ERROR_TOAST'));
            });
    } catch (e) {
        reportError(e as Error);
    }
};

const handleUpdateDataSubscription = (payload: UpdateDataPayload) => {
    if (payload.source === 'inspiration') {
        updateInspirationsStore(payload.data);
    }
};

export const initInspirationsPubsubApi = () => {
    window.ikea.pubsub.subscribe<InspirationEvent>(ADD_INSPIRATION_REQUEST, handleAddInspirationSubscription);
    window.ikea.pubsub.subscribe<InspirationEvent>(REMOVE_INSPIRATION_REQUEST, handleRemoveInspirationSubscription);
    window.ikea.pubsub.subscribe<UpdateDataEvent>(UPDATE_DATA, handleUpdateDataSubscription);
};
